import { render, staticRenderFns } from "./TableRolUserComponent.vue?vue&type=template&id=e017be5a"
import script from "./TableRolUserComponent.vue?vue&type=script&lang=js"
export * from "./TableRolUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports